<template>
  <div>
    <!-- 子 Tab 导航 -->
    <ul class="nav nav-pills nav-sm mb-3">
      <li class="nav-item">
        <button class="nav-link" :class="{ active: subTab === 'gifts' }" @click="subTab = 'gifts'">保底送礼</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: subTab === 'dispute' }" @click="subTab = 'dispute'">纠纷处理</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: subTab === 'challenge' }" @click="subTab = 'challenge'">挑战汇总</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: subTab === 'directGifts' }" @click="subTab = 'directGifts'">直购出奖明细</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: subTab === 'challengeOrders' }" @click="subTab = 'challengeOrders'">挑战订单明细</button>
      </li>
    </ul>

    <!-- 保底送礼 -->
    <div v-show="subTab === 'gifts'">
      <div class="card mb-3">
        <div class="card-header pb-0">
          <div>
            <h6>保底送礼记录</h6>
            <p class="text-xs text-secondary">全平台保底送礼汇总</p>
          </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
          <div v-if="giftLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
          <div v-else-if="gifts.length === 0" class="text-center text-secondary text-xs py-4">暂无数据</div>
          <div v-else class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-xs text-secondary font-weight-bolder opacity-7">订单号</th>
                  <th class="text-xs text-secondary font-weight-bolder opacity-7">设备ID</th>
                  <th class="text-xs text-secondary font-weight-bolder opacity-7">商户ID</th>
                  <th class="text-xs text-secondary font-weight-bolder opacity-7 text-center">状态</th>
                  <th class="text-xs text-secondary font-weight-bolder opacity-7 text-end">时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in gifts.slice(0, 15)" :key="item.order_no">
                  <td class="text-xs font-monospace">{{ item.order_no }}</td>
                  <td class="text-xs font-monospace">{{ item.board_id }}</td>
                  <td class="text-xs">{{ item.deliver_id }}</td>
                  <td class="text-center">
                    <span :class="giftStateClass(item)" class="badge">{{ giftStateText(item) }}</span>
                  </td>
                  <td class="text-xs text-end">{{ formatDateTime(item.created_date) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 纠纷处理（含明细记录展开） -->
    <div v-show="subTab === 'dispute'">
      <div class="row">
        <!-- 纠纷统计 -->
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <div class="card-header pb-0">
              <h6>纠纷统计</h6>
              <p class="text-xs text-secondary">全平台纠纷处理概况</p>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div v-if="disputeLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
              <div v-else-if="disputeStats.length === 0" class="text-center text-secondary text-xs py-4">暂无数据</div>
              <div v-else class="table-responsive p-0">
                <table class="table table-sm align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-xs text-secondary">设备ID</th>
                      <th class="text-xs text-secondary text-end">纠纷数</th>
                      <th class="text-xs text-secondary text-end">成功</th>
                      <th class="text-xs text-secondary text-end">失败</th>
                      <th class="text-xs text-secondary text-end">成功率</th>
                      <th class="text-xs text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in disputeStats.slice(0, 10)" :key="item.board_id">
                      <td class="text-xs font-monospace">{{ item.board_id }}</td>
                      <td class="text-xs text-end font-weight-bold">{{ item.dispute_count }}</td>
                      <td class="text-xs text-end text-success">{{ item.success_count }}</td>
                      <td class="text-xs text-end text-danger">{{ item.fail_count }}</td>
                      <td class="text-xs text-end">
                        <span :class="successRateClass(item)">{{ successRate(item) }}%</span>
                      </td>
                      <td class="align-middle">
                        <a href="javascript:;" class="text-secondary font-weight-bold text-xs" @click="toggleDisputeDetail(item.board_id)">明细</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- 纠纷明细记录展开 -->
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <div class="card-header pb-0 d-flex justify-content-between align-items-center">
              <div>
                <h6>纠纷明细记录</h6>
                <p class="text-xs text-secondary" v-if="disputeDetailBoard">设备 {{ disputeDetailBoard }} 的逐笔记录</p>
                <p class="text-xs text-secondary" v-else>点击左侧「明细」查看逐笔记录</p>
              </div>
              <button v-if="disputeDetailBoard" class="btn btn-sm btn-outline-secondary" @click="disputeDetailBoard = ''; disputeRecords = []">
                <i class="ni ni-fat-remove"></i> 关闭
              </button>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div v-if="disputeRecordLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
              <div v-else-if="!disputeDetailBoard" class="text-center text-secondary text-xs py-4">请点击左侧设备行的「明细」按钮</div>
              <div v-else-if="disputeRecords.length === 0" class="text-center text-secondary text-xs py-4">该设备暂无纠纷明细记录</div>
              <div v-else class="table-responsive p-0">
                <table class="table table-sm align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-xs text-secondary">订单号</th>
                      <th class="text-xs text-secondary">设备ID</th>
                      <th class="text-xs text-secondary text-center">类型</th>
                      <th class="text-xs text-secondary text-center">状态</th>
                      <th class="text-xs text-secondary text-end">时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in disputeRecords.slice(0, 20)" :key="item.order_no">
                      <td class="text-xs font-monospace">{{ item.order_no }}</td>
                      <td class="text-xs font-monospace">{{ item.board_id }}</td>
                      <td class="text-xs text-center">sub_{{ item.sub_cmd_type }}</td>
                      <td class="text-center">
                        <span :class="disputeStateClass(item)" class="badge text-xs">{{ disputeStateText(item) }}</span>
                      </td>
                      <td class="text-xs text-end">{{ formatDateTime(item.created_at) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 挑战汇总 -->
    <div v-show="subTab === 'challenge'">
      <div class="card">
        <div class="card-header pb-0">
          <h6>挑战收入汇总</h6>
          <p class="text-xs text-secondary">挑战 vs 直购收入对比</p>
        </div>
        <div class="card-body p-3">
          <div v-if="challengeLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
          <div v-else-if="challengeStats.length === 0" class="text-center text-secondary text-xs py-4">暂无数据</div>
          <div v-else>
            <div class="d-flex justify-content-around mb-3">
              <div class="text-center">
                <p class="text-xs text-secondary mb-0">挑战总收入</p>
                <h5 class="text-danger">¥{{ formatMoney(challengeTotal) }}</h5>
              </div>
              <div class="text-center">
                <p class="text-xs text-secondary mb-0">直购总收入</p>
                <h5 class="text-success">¥{{ formatMoney(directTotal) }}</h5>
              </div>
              <div class="text-center">
                <p class="text-xs text-secondary mb-0">挑战胜率</p>
                <h5 class="text-info">{{ challengeWinRate }}%</h5>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-sm align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-xs text-secondary">设备ID</th>
                    <th class="text-xs text-secondary text-end">挑战费</th>
                    <th class="text-xs text-secondary text-end">直购费</th>
                    <th class="text-xs text-secondary text-end">挑战次数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in challengeStats.slice(0, challengeDisplayLimit)" :key="item.board_id">
                    <td class="text-xs font-monospace">{{ item.board_id }}</td>
                    <td class="text-xs text-end">¥{{ formatMoney(item.sum_challenge_fee) }}</td>
                    <td class="text-xs text-end">¥{{ formatMoney(item.sum_direct_fee) }}</td>
                    <td class="text-xs text-end">{{ item.challenge_count }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-if="challengeStats.length > 8" class="text-center mt-2">
                <button v-if="challengeDisplayLimit === 8" class="btn btn-sm btn-outline-secondary" @click="challengeDisplayLimit = 9999">
                  显示全部 (共{{ challengeStats.length }}个设备)
                </button>
                <button v-else class="btn btn-sm btn-outline-secondary" @click="challengeDisplayLimit = 8">
                  收起
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 直购出奖明细 -->
    <div v-show="subTab === 'directGifts'">
      <DirectGiftReport :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'dg-' + deliverId + startDate" />
    </div>

    <!-- 挑战订单明细 -->
    <div v-show="subTab === 'challengeOrders'">
      <ChallengeOrderReport :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'co-' + deliverId + startDate" />
    </div>
  </div>
</template>

<script>
import { getGuaranteeGifts, getDisputeStats, getChallengeSummary, getDisputeRecords } from "@/api/dashboard";
import DirectGiftReport from "./DirectGiftReport.vue";
import ChallengeOrderReport from "./ChallengeOrderReport.vue";

export default {
  name: "OperationsHealth",
  components: { DirectGiftReport, ChallengeOrderReport },
  props: {
    days: { type: Number, default: 30 },
    deliverId: { type: Number, default: 0 },
    startDate: { type: Number, required: true },
    endDate: { type: Number, required: true },
  },
  data() {
    return {
      subTab: "gifts",
      gifts: [],
      disputeStats: [],
      challengeStats: [],
      challengeDisplayLimit: 8,
      giftLoading: false,
      disputeLoading: false,
      challengeLoading: false,
      disputeDetailBoard: "",
      disputeRecords: [],
      disputeRecordLoading: false,
    };
  },
  computed: {
    challengeTotal() {
      return this.challengeStats.reduce((sum, item) => sum + (item.sum_challenge_fee || 0), 0);
    },
    directTotal() {
      return this.challengeStats.reduce((sum, item) => sum + (item.sum_direct_fee || 0), 0);
    },
    challengeWinRate() {
      const total = this.challengeStats.reduce((sum, item) => sum + (item.challenge_count || 0), 0);
      const wins = this.challengeStats.reduce((sum, item) => sum + (item.challenge_win_count || 0), 0);
      if (total === 0) return 0;
      return ((wins / total) * 100).toFixed(1);
    },
  },
  mounted() {
    this.fetchAll();
  },
  methods: {
    formatMoney(fen) {
      if (!fen) return "0.00";
      return (fen / 100).toFixed(2);
    },
    formatDateTime(ts) {
      if (!ts) return "-";
      const d = new Date(ts * 1000);
      return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    },
    giftStateText(item) {
      const er = item && item.exec_result;
      if (er === 0) return "成功";
      if (er === null || er === undefined) return "待处理";
      return "失败";
    },
    giftStateClass(item) {
      const er = item && item.exec_result;
      if (er === 0) return "bg-success";
      if (er === null || er === undefined) return "bg-warning text-dark";
      return "bg-danger";
    },
    successRate(item) {
      if (!item.dispute_count || item.dispute_count === 0) return 0;
      return ((item.success_count / item.dispute_count) * 100).toFixed(1);
    },
    successRateClass(item) {
      const rate = parseFloat(this.successRate(item));
      if (rate < 50) return "text-danger font-weight-bold";
      if (rate < 80) return "text-warning";
      return "text-success";
    },
    disputeStateText(item) {
      if (item.exec_result === 0) return "成功";
      if (item.exec_result === null || item.exec_result === undefined) return "待处理";
      return "失败";
    },
    disputeStateClass(item) {
      if (item.exec_result === 0) return "bg-success";
      if (item.exec_result === null || item.exec_result === undefined) return "bg-warning text-dark";
      return "bg-danger";
    },
    async toggleDisputeDetail(boardId) {
      if (this.disputeDetailBoard === boardId) {
        this.disputeDetailBoard = "";
        this.disputeRecords = [];
        return;
      }
      this.disputeDetailBoard = boardId;
      await this.fetchDisputeRecords(boardId);
    },
    async fetchAll() {
      await Promise.all([
        this.fetchGifts(),
        this.fetchDisputeStats(),
        this.fetchChallengeSummary(),
      ]);
    },
    async fetchGifts() {
      this.giftLoading = true;
      try {
        const params = { start_date: this.startDate, end_date: this.endDate };
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getGuaranteeGifts(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          this.gifts = resp.desc;
        }
      } catch (err) {
        console.error("获取保底送礼失败:", err);
      } finally {
        this.giftLoading = false;
      }
    },
    async fetchDisputeStats() {
      this.disputeLoading = true;
      try {
        const params = { start_date: this.startDate, end_date: this.endDate };
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getDisputeStats(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          this.disputeStats = resp.desc.sort((a, b) => b.dispute_count - a.dispute_count);
        }
      } catch (err) {
        console.error("获取纠纷统计失败:", err);
      } finally {
        this.disputeLoading = false;
      }
    },
    async fetchChallengeSummary() {
      this.challengeLoading = true;
      try {
        const params = { start_date: this.startDate, end_date: this.endDate };
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getChallengeSummary(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          this.challengeStats = resp.desc.sort((a, b) => b.sum_challenge_fee - a.sum_challenge_fee);
        }
      } catch (err) {
        console.error("获取挑战汇总失败:", err);
      } finally {
        this.challengeLoading = false;
      }
    },
    async fetchDisputeRecords(boardId) {
      this.disputeRecordLoading = true;
      try {
        const params = { start_date: this.startDate, end_date: this.endDate, page: 1, page_size: 10000 };
        if (boardId) params.board_id = boardId;
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getDisputeRecords(params);
        if (resp.code === 0 && resp.desc) {
          let records = [];
          if (Array.isArray(resp.desc)) {
            records = resp.desc;
          } else if (resp.desc.records) {
            records = resp.desc.records;
          }
          this.disputeRecords = records;
        }
      } catch (err) {
        console.error("获取纠纷明细失败:", err);
      } finally {
        this.disputeRecordLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.nav-pills .nav-link {
  color: #6c757d;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}
.nav-pills .nav-link:hover {
  color: #344767;
  background-color: rgba(52, 71, 103, 0.08);
}
.nav-pills .nav-link.active {
  color: #fff;
  background-color: #344767;
  border-color: #344767;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(52, 71, 103, 0.2);
}
</style>
